var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "leftCardContainer" },
    [
      _c("div", { staticClass: "rightSideTitleActions" }, [
        _c("span", { staticClass: "leftTitle" }, [
          _vm._v(_vm._s(_vm.$t("Submitted") + " " + _vm.$tc("File", 2)))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "actionsContainer" }, [
          _c(
            "div",
            { staticClass: "searchContainer" },
            [
              _c("v-icon", [_vm._v(" search ")]),
              _vm._v(" "),
              _c("InputField", {
                attrs: {
                  inputType: "text",
                  value: _vm.search,
                  placeholder: _vm.$t("Search"),
                  inputStyle: {
                    borderRadius: "0px",
                    width: "130px",
                    borderTop: "none",
                    borderRight: "none",
                    borderLeft: "none",
                    borderBottom: "1px solid rgba(118, 118, 118, 0.50)"
                  }
                },
                on: {
                  input: function($event) {
                    return _vm.handleSearch($event)
                  }
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tabsContainer" },
        [
          _c("Tabs", {
            attrs: {
              activeTab: _vm.activeTab,
              tabs: _vm.tabs,
              centerTabs: false,
              "tabs-styling": _vm.tabsStyling,
              "tabs-labels-styling": _vm.tabsLabelsStyling
            },
            on: { startTabChange: _vm.setActiveTab }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tableDivContainer" },
        [
          _c("Table", {
            attrs: {
              "scroll-id": _vm.tableId,
              checkbox: false,
              loading: _vm.loading,
              headers: _vm.headers,
              items: _vm.imports,
              sortable: true,
              emitRowClickBusEvent: true,
              "has-imports-buttons": true,
              "has-delete-permission": _vm.userHasPermissionTo("destroy")
            },
            on: {
              validate: function($event) {
                return _vm.$emit("validate", $event)
              },
              onScrollBottom: _vm.onScrollBottom,
              onScrollTop: _vm.onScrollTop,
              sortClick: _vm.onSortClick
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("LoadingSpinner", {
        attrs: {
          active: _vm.deleteLoading,
          "is-full-page": true,
          color: "var(--app-primary-base)"
        },
        on: {
          "update:active": function($event) {
            _vm.deleteLoading = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b2960e8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2960e8a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/Data/Imports/TableViewSubmittedFiles.vue
// module id = null
// module chunks = 